import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldRadioModulo = ({
  modulo,
  propiedad,
  options,
  value,
  handleChange,
  readOnly,
  hidden,
  centered,
}) => {
  return (
    <S.Container className={hidden ? "hidden" : "visible"}>
      <S.RadioContainer centered={centered}>
        {options.map((option, index) => {
          const radioId = `radio-${modulo}-${propiedad}-${index}`; // Generar un ID único
          return (
            <S.RadioLabel key={option.value} htmlFor={radioId}>
              <S.RadioInput
                type="radio"
                id={radioId}
                name={`radio-${modulo}-${propiedad}`} // Nombre común para agrupar los radios
                value={option.value}
                checked={value === option.value}
                disabled={readOnly}
                onChange={(e) => handleChange(modulo, propiedad, e.target.value)}
              />
              {option.label}
            </S.RadioLabel>
          );
        })}
      </S.RadioContainer>
    </S.Container>
  );
};

FieldRadioModulo.propTypes = {
  modulo: PropTypes.string,
  propiedad: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  readOnly: PropTypes.bool,
  hidden: PropTypes.bool,
  centered: PropTypes.bool,
};